export const OVERVIEW_DUMMY_DATA = [
  {
    avatarUrl: "/img/widgets/people/person-female-3.png",
    name: "Emma Larsson",
    subtitle: "HR Manager",
    label: "🇸🇪 Sweden",
  },
  {
    avatarUrl: "/img/widgets/people/person-male-7.png",
    name: "Lucas Miller",
    subtitle: "Marketing Lead",
    label: "🇺🇸 United States",
  },
  {
    avatarUrl: "/img/widgets/people/person-male-8.png",
    name: "Rajiv Mehta",
    subtitle: "IT Support Specialist",
    label: "🇮🇳 India",
  },
];
